import React from "react";
import { AiOutlineFilePdf } from "react-icons/ai";
import { Typography, Box } from "@mui/material";

const LinkDownload = () => {
  return (
    <Box
      className={"pdfDownload"}
      width={"fit-content"}
      display={"flex"}
      border={"1px solid #FF0000"}
      padding={1}
      borderRadius={1}
      gap="5px"
      alignItems={"center"}
      justifyContent="center"
    >
      <Typography fontSize={14} color="black">
        Download PDF
      </Typography>
      <AiOutlineFilePdf fill="#FF0000" size={20} />
    </Box>
  );
};

export default LinkDownload;
